import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-defaultrepaymentmodal',
  templateUrl: './defaultrepaymentmodal.component.html',
  styleUrls: ['./defaultrepaymentmodal.component.css']
})
export class DefaultrepaymentmodalComponent implements OnInit {
  repayment: any;

  constructor() {
  }

  ngOnInit() {
  }

}
